import he from "he";
import { client } from "./client";
import type { SnipeItCategory, SnipeItModel, SnipeItStatusLabel } from "./types";

export async function fetchModelById(id: number): Promise<SnipeItModel | null> {
  try {
    const res = await client.get<SnipeItModel>(`/api/v1/models/${id}`);
    return { ...res.data, name: he.decode(res.data.name) };
  } catch {
    return null;
  }
}

export async function fetchStatusLabels(): Promise<SnipeItStatusLabel[]> {
  const res = await client.get<{ total: number; rows: SnipeItStatusLabel[] }>("/api/v1/statuslabels", {
    params: { limit: 100 },
  });
  return (res.data.rows ?? []).map((statusLabel) => ({ ...statusLabel, name: he.decode(statusLabel.name) }));
}

export async function searchModels(query: string): Promise<SnipeItModel[]> {
  if (!query) return [];
  const res = await client.get<{ total: number; rows: SnipeItModel[] }>("/api/v1/models", {
    params: { search: query, limit: 20 },
  });
  return (res.data.rows ?? []).map((m) => ({ ...m, name: he.decode(m.name) }));
}

export async function searchCategories(query: string): Promise<SnipeItCategory[]> {
  if (!query) return [];
  const res = await client.get<{ total: number; rows: SnipeItCategory[] }>("/api/v1/categories", {
    params: { search: query, limit: 20 },
  });
  return (res.data.rows ?? []).map((c) => ({ ...c, name: he.decode(c.name) }));
}

/** Fetches ALL models by walking through pages. */
export async function fetchAllModels(): Promise<SnipeItModel[]> {
  const pageSize = 500;
  const first = await client.get<{ total: number; rows: SnipeItModel[] }>("/api/v1/models", {
    params: { limit: pageSize, offset: 0, sort: "name", order: "asc" },
  });
  const all = (first.data.rows ?? []).map((m) => ({ ...m, name: he.decode(m.name) }));
  const total = first.data.total;
  for (let offset = pageSize; offset < total; offset += pageSize) {
    const page = await client.get<{ total: number; rows: SnipeItModel[] }>("/api/v1/models", {
      params: { limit: pageSize, offset, sort: "name", order: "asc" },
    });
    all.push(...(page.data.rows ?? []).map((m) => ({ ...m, name: he.decode(m.name) })));
  }
  return all;
}
